import styled from "styled-components";
import { COLORS, Typo } from "../../layout/theme";
import { Button } from "antd";

export const Inner = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 10px 20px;
	background-color: ${COLORS.White};
	border-radius: 20px;
	align-items: center;
	justify-content: space-between;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	transition: box-shadow 0.2s ease-in-out;

	&:hover {
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
	}
`;

export const QuotationInfo = styled.div`
	${(props) =>
		props.isMobile
			? `
      display: grid;
      grid-template-columns: repeat(2, minmax(150px, 1fr));
      width: 100%;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      `
			: `
      display: grid;
      grid-template-columns: repeat(7, minmax(150px, 1fr));
      width: 100%;
      align-items: center;
      justify-content: space-between;`}


	span {
		text-align: center;
	}
`;

export const QuotationDetails = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
	width: 100%;
	gap: 16px;
	padding-top: 16px;
	border-top: 1px solid ${COLORS.LightGrey};
	margin-top: 10px;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	justify-content: center;
	align-items: center;
	width: 100%;
`;

export const AntdButton = styled(Button)`
	border-radius: 10px;
	padding: 10px 20px;
`;

export const Section = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const TextEllipsis = styled(Typo)`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
	max-width: 100%;
	display: inline-block;
	cursor: default;
`;

/* ---------------------------------------------------------------------- */
/* Nuevos estilos para el panel de "Detalles" (rediseño visual)           */
/* ---------------------------------------------------------------------- */

export const DetailCard = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	background-color: ${COLORS.White};
	border: 1px solid ${COLORS.LightGrey};
	border-radius: 14px;
	padding: 16px;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
	transition: box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	}
`;

export const DetailCardHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 12px;
	padding-bottom: 8px;
	border-bottom: 1px solid ${COLORS.LightGrey};

	svg {
		flex-shrink: 0;
		color: ${(props) => props.iconColor || COLORS.Secondary};
	}
`;

export const DetailList = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const DetailListItem = styled.li`
	display: flex;
	align-items: flex-start;
	gap: 8px;
	line-height: 1.4;

	svg {
		flex-shrink: 0;
		margin-top: 3px;
		color: ${COLORS.Success};
	}
`;
